import { useGtm } from '@gtm-support/vue-gtm';

import { headerCase } from '@/core/lib/StringUtils';
import matomoEventMap, { type MatomoEventKey } from '@/domains/analytics/lib/MatomoEventMap';
import { captureError } from '@/domains/logger/lib/ApmUtils';

export const replacePlaceholders = (template: string, args?: Record<string, string | undefined>): string => {
  return template
    .replaceAll(/\$\{(\w+)\}/g, (match: string, p1: string): string => {
      const value = args?.[p1];

      if (!value) {
        return '';
      }

      return headerCase(value);
    })
    .replaceAll(/--+/g, '-')
    .replaceAll(/-$/g, '');
};

const trackMatomoEvent = (key: MatomoEventKey, args?: Record<string, string | undefined>): void => {
  try {
    const { categorie, action, nom } = matomoEventMap[key];

    const gtm = useGtm();

    if (!gtm) {
      throw new Error('GTM introuvable.');
    }

    gtm.trackEvent({
      event: 'mtm_app',
      evenement_description: {
        EvenementCategorie: categorie,
        EvenementAction: action,
        EvenementNom: replacePlaceholders(nom, args),
      },
    });
  } catch (e) {
    console.warn(`Problème lors du tracking de l'événement Matomo "${key}".`, e);
    captureError(e);
  }
};

export default trackMatomoEvent;
